var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"7e696ef75da1b6759be12cd0743f50c9d2949123"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';
import createSentryBeforeSend from '@rockalingua/shared/monitoring/functions/createSentryBeforeSend';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_ROCKALINGUA_ENVIRONMENT,
  tracesSampleRate: 0.0,
  release: process.env.NEXT_PUBLIC_BUILD_VERSION,
  beforeSend: createSentryBeforeSend('web', process.env.NODE_ENV),
});
